var render = function () {
  var _vm$itemsDisplayed;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    staticClass: "d-flex flex-column align-center justify-center",
    attrs: {
      "color": "transparent"
    }
  }, [!((_vm$itemsDisplayed = _vm.itemsDisplayed) !== null && _vm$itemsDisplayed !== void 0 && _vm$itemsDisplayed.length) ? _c('p', {
    staticClass: "d-span text-center primary--text font-weight-bold secondary rounded-pill py-4 px-8"
  }, [_vm._v(" " + _vm._s(_vm.noDataText) + " ")]) : _vm._e(), _vm._l(_vm.itemsDisplayed, function (item) {
    return _c('new-material-item', {
      key: item.id,
      attrs: {
        "item": item
      }
    });
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }